// @flow
import React from 'react';

import styles from './styles.module.scss';
import { useSelector } from 'react-redux';
import Legend from './Legend';
import Graph from './Graph';
import StrategyPercentageBar from '../../../components/StrategyPercentageBar';

const RangeGraph = ({ concealed = false }: { concealed?: boolean }) => {
  const { openStats } = useSelector((state) => state.game);
  const {
    fold, limp, call, check, raise,
  } = openStats || 0;

  if (!openStats) return <></>;

  return (
    <div className={styles.container} style={concealed ? { visibility: 'hidden' } : undefined} aria-hidden={concealed || undefined}>
      <div className={styles.headWrapper}>
        <div className={styles.legendWrapper}>
          { fold > 0 && <Legend text="Fold" className={`${styles.fold} ${styles.circleLegend}`} /> }
          { call > 0 && <Legend text="Call" className={`${styles.call} ${styles.circleLegend}`} /> }
          { check > 0 && <Legend text="Check" className={`${styles.call} ${styles.circleLegend}`} /> }
          { limp > 0 && <Legend text="Call" className={`${styles.call} ${styles.circleLegend}`} /> }
          { raise > 0 && <Legend text="Raise" className={`${styles.raise} ${styles.circleLegend}`} /> }
        </div>
      </div>
      <StrategyPercentageBar
        Graph={Graph}
        className={styles.graphWrapper}
        segments={[
          {
            id: 'fold', width: fold, className: styles.fold, label: `Fold: ${fold}% of hands`,
          },
          {
            id: 'call', width: call, className: styles.call, label: `Call: ${call}% of hands`,
          },
          {
            id: 'check', width: check, className: styles.call, label: `Check: ${check}% of hands`,
          },
          {
            id: 'limp', width: limp, className: styles.call, label: `Call: ${limp}% of hands`,
          },
          {
            id: 'raise', width: raise, className: styles.raise, label: `Raise: ${raise}% of hands`,
          },
        ]}
      />
    </div>
  );
};

export default RangeGraph;
